import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "companyInfo", "loading", "form", "hiddenFields", "establishmentsData", "companyName", "nafCode", "address", "siren"]

  connect() {
    this.minLength = 9
    this.timeout = null
    this.inputTarget.focus()
  }

  formatSiren(event) {
    let value = event.target.value.replace(/\D/g, '') // Remove non-digits
    if (value.length > 9) value = value.slice(0, 9) // Limit to 9 digits
    
    // Add spaces after every 3 digits for display
    const formatted = value.replace(/(\d{3})(?=\d)/g, '$1 ')
    event.target.value = formatted
    
    // Store unformatted value in a data attribute
    event.target.dataset.unformattedValue = value
    
    // Trigger search with unformatted value
    if (value.length === this.minLength) {
      this.search(value)
    } else {
      this.companyInfoTarget.innerHTML = ""
    }
  }

  updateHiddenFields(event) {
    const index = parseInt(event.target.dataset.establishmentIndex)
    const establishments = JSON.parse(this.establishmentsDataTarget.dataset.establishments)
    const establishment = establishments[index]

    if (establishment) {
      this.companyNameTarget.value = establishment.company_name
      this.nafCodeTarget.value = establishment.naf_code
      this.addressTarget.value = establishment.address || ''
      this.sirenTarget.value = establishment.siren.toString().replace(/\s+/g, '')
    }
  }

  search(value) {
    if (value.length === this.minLength) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.fetchCompanyInfo(value)
      }, 300)
    }
  }

  async fetchCompanyInfo(siren) {
    try {
      this.showLoading()
      
      const response = await fetch(`/account_applications/company_info?siren=${siren}`, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      const contentType = response.headers.get("Content-Type")
      
      if (contentType.includes("text/vnd.turbo-stream.html")) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        throw new Error("Unexpected response format")
      }
    } catch (error) {
      console.error("Error:", error)
      this.displayError("Unable to fetch company information. Please try again.")
    } finally {
      this.hideLoading()
    }
  }

  displayError(message) {
    const errorHtml = `
      <div class="mt-6 rounded-md bg-destructive/15 p-4">
        <div class="flex gap-3">
          <i data-lucide="circle-alert" class="h-5 w-5 text-destructive flex-shrink-0"></i>
          <p class="text-sm text-destructive">
            ${message}
          </p>
        </div>
      </div>
    `
    this.companyInfoTarget.innerHTML = errorHtml
    if (window.Lucide) window.Lucide.createIcons()
  }

  showLoading() {
    this.loadingTarget.classList.remove('hidden')
  }

  hideLoading() {
    this.loadingTarget.classList.add('hidden')
  }
}
